webpackJsonp([1],Array(47).concat([
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(104)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(151),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5ee2a7b4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Projects__);




// import Project from '@/components/Project'
// import Current from '@/components/Current'
// import Info from '@/components/Info'
// import News from '@/components/News'

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    redirect: '/current'
  }, {
    path: '/current',
    name: 'Current',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Projects___default.a,
    props: true
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Projects___default.a,
    props: true
  }, {
    path: '/info',
    name: 'Info',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Projects___default.a
    // component: Info
  },
  // {
  //   path: '/news',
  //   name: 'News',
  //   component: News
  // },
  {
    path: '*',
    redirect: '/'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    var position = { x: 0, y: 0
      // Keep scroll position when using browser buttons
    };if (savedPosition) {
      position = savedPosition;
    }
    // Workaround for transitions scrolling to the top of the page
    // However, there are still some problems being fixed by the vue team
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      setTimeout(function () {
        resolve(position);
      }, 1000);
    });

    // return {}
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({ left: 0, top: 0 })
    //   }, 500)
    // })
    // return savedPosition
    // if (to.name === 'Projects') {
    //   return false
    // }
    // else if (to.name === 'Current') {
    //   return false
    // }
    //   // return {
    //   //   el: '#projects',
    //   //   top: -10
    //   // }
    // if (savedPosition) {
    //   return savedPosition
    // }
    // return {}
    // else {
    // return { 
    //   x: 0, y: 0,
    //   behavior: 'smooth'
    // }
    // }
    // else if (to.name === 'Projects') {
    //   return { x: 0, y: 0 }
    // }
    // {
    //   return { x: 0, y: 1000 }
    // }
  }
}));

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(102)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(58),
  /* template */
  __webpack_require__(149),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismic_dom__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismic_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismic_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_progressbar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_progressbar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_progressbar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_check_view__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_check_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_check_view__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_check_view___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.autoOpenBrowser = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.PRISMIC = __webpack_require__.i({"API":"https://matthieulavanchy.prismic.io/api/v2"});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.IMGS = __webpack_require__.i({"BASE":"https://res.cloudinary.com/matthieu-lavanchy"});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.bkpt = {
  mobile: 600,
  prjGrid_2col: 600
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$html = function (key) {
  return __WEBPACK_IMPORTED_MODULE_3_prismic_dom___default.a.RichText.asHtml(key, function () {
    return '/';
  });
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_lazyload___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_progressbar___default.a, {
  color: 'lightgray',
  thickness: '2px'
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//

var inBrowser = typeof window !== 'undefined';
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'VueProgress',
    serverCacheKey: function serverCacheKey() {
        return 'Progress';
    },
    computed: {
        style: function style() {
            var location = this.progress.options.location;
            var style = {
                'background-color': this.progress.options.canSuccess ? this.progress.options.color : this.progress.options.failedColor,
                'opacity': this.progress.options.show ? 1 : 0
            };
            if (location == 'top' || location == 'bottom') {
                location === 'top' ? style.top = '0px' : style.bottom = '0px';
                if (!this.progress.options.inverse) {
                    style.left = '0px';
                } else {
                    style.right = '0px';
                }
                style.width = this.progress.percent + '%';
                style.height = this.progress.options.thickness;
                style.transition = "width " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            } else if (location == 'left' || location == 'right') {
                location === 'left' ? style.left = '0px' : style.right = '0px';
                if (!this.progress.options.inverse) {
                    style.bottom = '0px';
                } else {
                    style.top = '0px';
                }
                style.height = this.progress.percent + '%';
                style.width = this.progress.options.thickness;
                style.transition = "height " + this.progress.options.transition.speed + ", opacity " + this.progress.options.transition.opacity;
            }
            return style;
        },
        progress: function progress() {
            if (inBrowser) {
                return window.VueProgressBarEventBus.RADON_LOADING_BAR;
            } else {
                return {
                    percent: 0,
                    options: {
                        canSuccess: true,
                        show: false,
                        color: 'rgb(19, 91, 55)',
                        failedColor: 'red',
                        thickness: '2px',
                        transition: {
                            speed: '0.2s',
                            opacity: '0.6s',
                            termination: 300
                        },
                        location: 'top',
                        autoRevert: true,
                        inverse: false
                    }
                };
            }
        }
    }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_javascript__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prismic_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Nav__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Navv: __WEBPACK_IMPORTED_MODULE_2__components_Nav___default.a
  },
  data: function data() {
    return {
      transition: 'page',
      savedPosition: 0,
      info: null,
      projects: null,
      current: null,
      // news: null,
      entering: false
    };
  },

  computed: {
    navVisible: function navVisible() {
      // return this.$route.name.indexOf('Project') === -1 || this.$route.name.indexOf('Current') === -1
      return this.$route.name === 'Info';
    }
  },
  watch: {
    '$route': function $route(to, from) {
      // console.log(this.$route.name);
      // save Projects scroll position
      var prjs = this.$el.querySelector('.projects .main');
      if (prjs) this.savedPosition = prjs.scrollTop;
      // transitions
      if (from.name.indexOf('Project') === 0) this.transition = 'slidedown';else if (from.name.indexOf('Current') === 0) this.transition = 'slidedown';else if (to.name.indexOf('Project') === 0) this.transition = 'slideup';else if (to.name.indexOf('Current') === 0) this.transition = 'slideup';else this.transition = 'page';
      // console.log('this.transition', this.transition)
    }
  },
  mounted: function mounted() {
    var setVh = function setVh() {
      // console.log('setVh');
      var vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', vh + 'px');
    };
    window.addEventListener('load', setVh);
    window.addEventListener('resize', setVh);
  },

  methods: {
    getProjects: function getProjects() {
      var _this = this;

      this.$Progress.start();
      // Get the Order
      __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.getApi(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.PRISMIC.API).then(function (api) {
        return api.query(__WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.Predicates.at('document.type', 'projects-index'));
      }).then(function (response) {
        var prjs = response.results[0].data.projects;
        var projectIDs = [];
        for (var i = 0; i < prjs.length; i++) {
          projectIDs.push(prjs[i].project.id);
        }
        // Get the Projects
        __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.getApi(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.PRISMIC.API).then(function (api) {
          return api.query(__WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.Predicates.in('document.id', projectIDs), { pageSize: 100 });
        }).then(function (response) {
          _this.$Progress.finish();
          _this.projects = response.results;
        }, function (err) {
          _this.$Progress.fail();
          console.log('Error: Get Projects failed', err);
        });
      }, function (err) {
        _this.$Progress.fail();
        console.log('Error: Get Project Index failed', err);
      });
    },
    getInfo: function getInfo() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.getApi(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.PRISMIC.API).then(function (api) {
        return api.getSingle('info');
      }).then(function (response) {
        _this2.info = response;
      }, function (err) {
        console.log('Error: Get Info failed', err);
      });
    },
    getCurrent: function getCurrent() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_1_prismic_javascript___default.a.getApi(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.PRISMIC.API).then(function (api) {
        return api.getSingle('current');
      }).then(function (response) {
        _this3.current = response;
        // this.projects.current = response
      }, function (err) {
        console.log('Error: Get Current failed', err);
      });
    }
    // getNews () {
    //   Prismic.getApi(Vue.config.PRISMIC.API).then((api) => {
    //     return api.query(
    //       Prismic.Predicates.at('document.type', 'news'),
    //       {pageSize: 6, page: 1, orderings: '[document.date desc]'}
    //     )
    //   }).then((response) => {
    //     this.news = response.results
    //   }, (err) => {
    //     this.$Progress.fail()
    //     console.log('Error: getNews', err)
    //   })
    // }

  },
  created: function created() {
    this.getCurrent();
    this.getProjects();
    this.getInfo();
    // this.getNews()
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Copyright',
  props: {
    credits: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showCredits: false
    };
  },

  computed: {
    year: function year() {
      var date = new Date();
      return date.getFullYear();
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CurrentProject__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CurrentProject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_CurrentProject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//




 // '@/scripts/scrollTo'
// import VueScrollTo from '@/scripts/scrollTo'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Current',
  data: function data() {
    return {
      transition: null,
      currentSlide: 0,
      sliderThrottle: 850 // window.innerWidth > Vue.config.bkpt.mobile ? 950 : 700
    };
  },

  props: ['current'],
  components: {
    CurrentProject: __WEBPACK_IMPORTED_MODULE_1__components_CurrentProject___default.a
  },
  watch: {
    currentSlide: function currentSlide() {
      if (this.slides[this.currentSlide].gray_slide) {
        console.log('GREY SLIDE visible in Current');
        this.$parent.mobileGreySlide = true;
        // if the window width is mobile
        if (window.innerWidth > __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.bkpt.mobile) {
          this.hideTitle(this.sliderThrottle + 100);
        }
      } else {
        // not grey slide
        this.$parent.mobileGreySlide = false;
      }
    }
  },
  computed: {
    slides: function slides() {
      var c = this.current;
      if (c && c.data && c.data.slides && c.data.slides.length) {
        return c.data.slides;
      }
    }
  },
  methods: {
    nextIndex: function nextIndex() {
      return this.current + 1 === this.projects.length ? 0 : this.current + 1;
    },
    viewerClick: function viewerClick(e) {
      var prev = e.clientX - e.target.offsetLeft < e.target.offsetWidth / 2;
      if (prev) return this.previous();
      return this.next();
    },

    next: __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
      this.transition = 'slideleft';
      var lastSlide = this.currentSlide === this.slides.length - 1;
      if (lastSlide) {
        // this.current = this.current + 1 > this.projects.length - 1 ? 0 : this.current + 1
        this.currentSlide = 0;
        // this.hideTitle()
      } else {
        this.currentSlide++;
      }
    }, this.sliderThrottle),
    previous: __WEBPACK_IMPORTED_MODULE_2_lodash_throttle___default()(function () {
      this.transition = 'slideright';
      var firstSlide = this.currentSlide - 1 < 0;
      if (firstSlide) {
        // this.current = this.current - 1 < 0 ? this.projects.length - 1 : this.current - 1
        this.currentSlide = this.slides.length - 1;
      } else {
        this.currentSlide--;
        // if (this.currentSlide === 0) this.hideTitle()
      }
    }, this.sliderThrottle),
    // scrollToViewer (duration = 1000) {
    //   this.$nextTick(() => {
    //     if (this.$refs.viewer) return VueScrollTo.scrollTo(this.$refs.viewer, duration)
    //   })
    // },
    hideTitle: function hideTitle() {
      var _this = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // this.titleTmOut = setTimeout(() => { this.titleVisible = false }, delay)
      this.titleTmOut = setTimeout(function () {
        _this.$parent.titleVisible = false;
      }, delay);
    },
    showTitle: function showTitle(prismicText, timeoutOnTouch) {
      // console.log('showTitle', prismicText)
      // this.$emit('showTitle', prismicText)
      // console.log(this.$parent)
      this.$parent.showTitle(prismicText, timeoutOnTouch);

      // if (this.infoInvisible) {
      //   this.title = Vue.$html(prismicText)
      //   this.titleVisible = true
      //   clearTimeout(this.titleTmOut)
      //   // if (timeoutOnTouch) {
      //     // if (Modernizr.touchevents) this.hideTitle(2000)
      //   // }
      // }
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
//
//
//
//
//
//
//
//
//
//
//
//
//



var Modernizr = window.Modernizr;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CurrentProject',
  props: ['title', 'current', 'slides', 'transition'],
  inheritAttrs: false,
  data: function data() {
    return {
      winW: window.innerWidth
    };
  },

  methods: {
    empty: function empty(value) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(value);
    },

    // cloudinary resize function?
    // imgSrc (src, portrait = false) {
    //   if (!src) return ''
    //   let t = portrait ? 'w_400' : 'w_800' // mobile (based on width)
    //   t = this.winW > 600 ? 'h_800' : t // tablet / laptop
    //   t = this.winW > 1280 ? 'h_1280' : t // large
    //   return Vue.config.IMGS.BASE + '/image/fetch/' + t + '/' + src
    // },
    imgSrc: function imgSrc(src) {
      var portrait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!src) return '';
      var t = portrait ? 'w=800' : 'w=1600'; // mobile (based on width)
      t = this.winW > 600 ? 'h=1600' : t; // tablet / laptop
      t = this.winW > 1280 ? 'h=2560' : t; // large
      return src + '&' + t;
    },
    imgHover: function imgHover() {
      var entered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      console.log('imgHover');
      if (!Modernizr.touchevents) {
        if (entered) return this.$emit('imgHover');
        return this.$emit('imgLeave');
      }
    },
    isPortrait: function isPortrait(img) {
      return img ? img.dimensions.width < img.dimensions.height : false;
    }
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Copyright__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Copyright__);
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Info',
  props: ['info'],
  inheritAttrs: false,
  components: {
    Copyright: __WEBPACK_IMPORTED_MODULE_1__components_Copyright___default.a
  },
  data: function data() {
    return {
      html: __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].$html
    };
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//

// var Vue = require('vue')
// var VueScrollTo = require('vue-scrollto')
 // '@/scripts/scrollTo'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Nav',
  props: ['visible', 'type', 'showInfo'],
  data: function data() {
    return {
      isScrolling: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    var current = this.$router.currentRoute.name;
    if (current === 'Projects') {
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#projects', 1000, { container: '.main', offset: -50 });
      }, 1100);
    } else if (current === 'Info') {
      setTimeout(function () {
        _this.navto("info");
      }, 1100);
    }
  },

  methods: {
    navto: function navto(target) {
      var _this2 = this;

      console.log('navto', target);
      this.isScrolling = true;
      setTimeout(function () {
        _this2.isScrolling = false;
      }, 1010);

      var current = this.$router.currentRoute.name;
      // console.log(current)

      if (current === 'Info') {
        if (target === 'info') {
          console.log('open info 1');
          // this.$emit('openInfo')
          this.$parent.showInfo = true;
        }
        // go back home
        this.$router.push({
          path: '/' + target
          // replace: true
        });
        if (target === 'projects') {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#projects', 1000, { container: '.main', offset: -50 });
          }, 1020);
        }
        if (target === 'current') {
          setTimeout(function () {
            __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#current', 1000, { container: '.main' });
          }, 1020);
        }
      } else {
        // we're on the main page
        this.$router.push({
          path: '/' + target,
          replace: true
        });

        if (target === 'info') {
          // slide down the page to show info under it
          // ... the route watch does in in Projects.vue
          console.log('open info 2');
          this.$parent.showInfo = true;
        } else if (target === 'current') {
          // VueScrollTo.scrollTo('#app', 1000)
          __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#app', 1000, { container: '.main' });
        } else if (target === 'projects') {
          // VueScrollTo.scrollTo('#projects', 1000)
          __WEBPACK_IMPORTED_MODULE_0_vue_scrollto___default.a.scrollTo('#projects', 1000, { container: '.main', offset: -50 });
        }
      }

      // else if (target === 'current') {
      //   const el = document.querySelector('#app')
      //   VueScrollTo.scrollTo(el, 1000)

      // } else if (target === 'projects') {
      //   const el = document.querySelector('#projects')
      //   setTimeout(() => {
      //     VueScrollTo.scrollTo(el, 1000)
      // this.$router.push({
      //   path: '/'+target,
      //   replace: true
      // })
      //   }, 1000)
      // }
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var Modernizr = window.Modernizr;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Project',
  props: ['title', 'current', 'slides', 'transition', 'preload'],
  inheritAttrs: false,
  data: function data() {
    return {
      winW: window.innerWidth
    };
  },

  methods: {
    empty: function empty(value) {
      return __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(value);
    },

    // imgSrc (src, portrait = false) {
    //   if (!src) return ''
    //   let t = portrait ? 'w_400' : 'w_800' // mobile (based on width)
    //   t = this.winW > 600 ? 'h_800' : t // tablet / laptop
    //   t = this.winW > 1280 ? 'h_1280' : t // large
    //   return Vue.config.IMGS.BASE + '/image/fetch/' + t + '/' + src
    // },
    imgSrc: function imgSrc(src) {
      var portrait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!src) return '';
      var t = portrait ? 'w=800' : 'w=1600'; // mobile (based on width)
      t = this.winW > 600 ? 'h=1600' : t; // tablet / laptop
      t = this.winW > 1280 ? 'h=2560' : t; // large
      return src + '&' + t;
    },
    imgHover: function imgHover() {
      var entered = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!Modernizr.touchevents) {
        if (entered) return this.$emit('imgHover');
        return this.$emit('imgLeave');
      }
    },
    isPortrait: function isPortrait(img) {
      return img ? img.dimensions.width < img.dimensions.height : false;
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Nav___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Nav__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Project__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Project___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Project__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Current__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Current___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Current__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Info__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_scrollto__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








 // '@/scripts/scrollTo'
// import VueScrollTo from '@/scripts/scrollTo'
var Modernizr = window.Modernizr;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "Projects",
  props: ['projects', 'entering', 'savedPosition', 'currentData', 'info'],
  inheritAttrs: false,
  components: {
    Project: __WEBPACK_IMPORTED_MODULE_1__components_Project___default.a,
    Current: __WEBPACK_IMPORTED_MODULE_2__components_Current___default.a,
    Navv: __WEBPACK_IMPORTED_MODULE_0__components_Nav___default.a,
    Info: __WEBPACK_IMPORTED_MODULE_3__components_Info___default.a
  },
  data: function data() {
    return {
      grayBg: false,
      leaving: false,
      projectView: false,
      transition: null,
      current: 0,
      currentSlide: 1,
      title: '',
      titleVisible: false,
      titleTmOut: null,
      nearProjectView: false,
      snapTmOut: null,
      infoInvisible: false,
      sliderThrottle: 850, // window.innerWidth > Vue.config.bkpt.mobile ? 950 : 700
      showMenu: true,
      showInfo: false,
      currentView: true,
      mobileGreySlide: false,
      st: 0
      // aboveMenu: false,
      // honk: true
    };
  },

  computed: {
    classes: function classes() {
      return {
        'projects--projectview': this.projectView || this.$route.name === 'Current',
        'projects--projects-loaded': this.projectsLoaded,
        'projects--animating': this.leaving || this.entering,
        'show--info': this.showInfo,
        'gray--bg': this.grayBg
        // 'above--menu': this.aboveMenu
      };
    },
    scrollBody: function scrollBody() {
      return window;
    },
    thumbSize: function thumbSize() {
      var w = window.innerWidth;
      var size = 'mobile';
      size = w > 414 && w <= __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.bkpt.prjGrid_2col ? 'medium' : size;
      size = w > 2048 ? 'large' : size;
      return size;
    },
    nextIndex: function nextIndex() {
      return this.current + 1 === this.projects.length ? 0 : this.current + 1;
    },
    infoTransition: function infoTransition() {
      return this.infoInvisible ? 'bar' : 'intro';
    },
    projectViewMobile: function projectViewMobile() {
      if (window.innerWidth <= __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].config.bkpt.mobile) {
        // is mobile
        if (this.projectView) return true;else if (this.st <= 0) return true;else return false;
      } else return false;
    }
  },

  watch: {
    projects: function projects() {
      this.hideInfoBar(4000);
    },
    $route: function $route() {
      var r = this.$route.name;
      if (r === 'Info') {
        this.showInfo = true;
      } else {
        this.showInfo = false;
      }
      if (r === 'Current') {
        this.currentView = true;
      } else {
        this.currentView = false;
      }
    },

    // entering (entering) {
    //   if (entering) {
    //     this.$nextTick(() => {
    //       // this.$refs.scrollbody.scrollTop = this.savedPosition
    //     })
    //   } else { // entered
    //     this.$nextTick(() => {
    //       document.body.scrollTop = this.savedPosition
    //     })
    //   }
    // },
    projectView: function projectView(entering) {
      // console.log('projectView', entering)
      // if (entering) {
      //   this.hideTitle()
      // } else { // leaving
      //   if (this.projects) {
      //     this.showTitle(this.projects[this.current].data.title)
      //     this.hideTitle(1200)
      //   }
      // }
    },
    infoInvisible: function infoInvisible() {
      // console.log('infoInvisible', this.infoInvisible)
    },
    title: function title() {
      // console.log('title', this.title)
    }
  },

  methods: {
    handleScroll: function handleScroll(e) {
      var st = this.$refs.scrollbody.scrollTop;
      var projects = this.$refs.projects;
      var projectsDistanceTop = projects.offsetTop - 200;
      var viewer = this.$refs.viewer;
      var viewerDistanceTop = viewer.offsetTop - 200;

      if (st > projectsDistanceTop && st < viewerDistanceTop) {
        // console.log('projects');
        this.$router.push({ name: 'Projects', replace: true });
        this.projectView = false;
        this.grayBg = true;
      } else if (st > viewerDistanceTop) {
        // console.log('viewer');
        this.projectView = true;
        this.grayBg = false;
      } else if (st < projectsDistanceTop) {
        // console.log('current');
        this.$router.push({ name: 'Current', replace: true });
        this.projectView = false;
        this.grayBg = false;
      }

      this.st = st;
    },
    viewHandler: function viewHandler(e) {
      var r = this.$router.currentRoute.name;

      // console.log(e)
      //  && r !== 'information'
      if (e.percentTop <= 0.85 && r !== 'projects' && e.scrollPercent !== 0 || e.type === 'exit' && e.scrollPercent !== 0 && e.scrollPercent > 1) {
        this.$router.push({ name: 'Projects', replace: true });
        // console.log('projects')
        // console.log(e);
      } else if (r !== 'current' && e.type !== 'exit' && e.percentTop > 0.85) {
        this.$router.push({ name: 'Current', replace: true });
      }
    },
    html: function html(key) {
      return __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].$html(key);
    },
    thumb: function thumb(doc) {
      if (doc.data.thumbnail) {
        var src = doc.data.thumbnail[this.thumbSize];
        return src ? src.url : doc.data.thumbnail.url;
      }
      return '';
    },
    open: function open(prjIndex) {
      this.current = prjIndex;
      // this.currentSlide = 0
      this.currentSlide = 1;
      this.transition = 'none';
      this.showTitle(this.projects[this.current].data.title);
      // this.scrollToViewer()
      __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default.a.scrollTo('#viewer', 1000, { container: '.main' });
    },
    showTitle: function showTitle(prismicText, timeoutOnTouch) {
      // console.log('showTitle')
      if (this.infoInvisible) {
        if (Array.isArray(prismicText)) {
          this.title = __WEBPACK_IMPORTED_MODULE_4_vue__["a" /* default */].$html(prismicText);
        } else if (typeof prismicText === 'string') {
          this.title = prismicText;
        }
        this.titleVisible = true;
        // clearTimeout(this.titleTmOut)
        // if (timeoutOnTouch) {
        // if (Modernizr.touchevents) this.hideTitle(2000)
        // }
      }
    },
    hideTitle: function hideTitle() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // this.titleTmOut = setTimeout(() => { 
      // console.log('hideTitle')
      this.titleVisible = false;
      // }, delay)
    },
    thumbHover: function thumbHover(key) {
      if (Modernizr) if (!Modernizr.touchevents) this.showTitle(key);
    },
    infoClick: function infoClick() {
      var _this = this;

      this.projectView = false;
      var delay = this.projectView ? 200 : 0;
      var go = function go() {
        _this.$router.push({ name: 'Info' });
      };
      setTimeout(go, delay);
    },
    currentClick: function currentClick() {},
    projectsClick: function projectsClick() {},
    hideInfoBar: function hideInfoBar() {
      var _this2 = this;

      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // console.log('hideInfoBar', delay)
      // old
      if (this.projects) setTimeout(function () {
        _this2.infoInvisible = true;
      }, delay);
      // new
      if (this.projects) setTimeout(function () {

        var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
        // if w is less than iphone 13 width
        if (width > 960) {
          _this2.showMenu = false;
        }
      }, delay);
    },
    viewerClick: function viewerClick(e) {
      var prev = e.clientX - e.target.offsetLeft < e.target.offsetWidth / 2;
      if (prev) return this.previous();
      return this.next();
    },


    next: __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(function () {
      this.transition = 'slideleft_old';
      var lastSlide = this.currentSlide + 1 > this.projects[this.current].data.slides.length;
      if (lastSlide) {
        this.current = this.current + 1 > this.projects.length - 1 ? 0 : this.current + 1;
        this.currentSlide = 0;
        this.hideTitle(950);
      } else {
        this.currentSlide++;
      }
    }, this.sliderThrottle),

    previous: __WEBPACK_IMPORTED_MODULE_5_lodash_throttle___default()(function () {
      this.transition = 'slideright_old';
      var firstSlide = this.currentSlide - 1 < 0;
      if (firstSlide) {
        this.current = this.current - 1 < 0 ? this.projects.length - 1 : this.current - 1;
        this.currentSlide = this.projects[this.current].data.slides.length;
      } else {
        this.currentSlide--;
        if (this.currentSlide === 0) this.hideTitle(950);
      }
    }, this.sliderThrottle),

    scrollToViewer: function scrollToViewer() {
      var _this3 = this;

      var duration = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;

      this.$nextTick(function () {
        // console.log('HONK HONK');
        if (_this3.$refs.viewer) return __WEBPACK_IMPORTED_MODULE_6_vue_scrollto___default.a.scrollTo(_this3.$refs.viewer, duration);
      });
    },


    // onScroll: _throttle(function () {
    //   const viewBottom = window.pageYOffset + window.innerHeight
    //   const scrollBottom = document.body.scrollHeight
    //   // in project view ?
    //   const buffer = window.innerHeight / 8
    //   this.projectView = viewBottom >= scrollBottom - buffer
    //   // snap to project view ?
    //   clearTimeout(this.snapTmOut)
    //   this.snapTmOut = setTimeout(() => {
    //     const offset = window.innerHeight / 3
    //     const nearProjectView = viewBottom >= scrollBottom - offset
    //     if (nearProjectView) this.scrollToViewer(1000)
    //   }, 300)
    // }, 100),

    bindScroll: function bindScroll() {
      var _this4 = this;

      // window.addEventListener('scroll', this.onScroll)
      setTimeout(function () {
        if (_this4.$refs.scrollbody) {
          _this4.$refs.scrollbody.addEventListener('scroll', _this4.handleScroll);
        } else {
          setTimeout(function () {
            _this4.$refs.scrollbody.addEventListener('scroll', _this4.handleScroll);
          }, 1110);
        }
      }, 1110);
    }
  },

  mounted: function mounted() {
    this.hideInfoBar(2000);
    this.bindScroll();
  },


  // beforeRouteLeave (to, from, next) {
  //   const y = window.pageYOffset
  //   this.leaving = true
  //   this.$nextTick(() => {
  //     this.$refs.scrollbody.scrollTop = y
  //     next()
  //   })
  // },

  destroy: function destroy() {
    window.removeEventListener('scroll', this.onScroll);
    this.$refs.scrollbody.addEventListener('scroll', this.handleScroll);
  }
});

/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 102 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 103 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 106 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 107 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 108 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(107)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(154),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7b727cd0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(108)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(60),
  /* template */
  __webpack_require__(155),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7d1586ec",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(106)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(153),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(100)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(147),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(105)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(152),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(103)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(150),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5150ec39",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(101)
}
var Component = __webpack_require__(3)(
  /* script */
  __webpack_require__(57),
  /* template */
  __webpack_require__(148),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-page"
  }, [(_vm.info) ? _c('article', [_c('section', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.info.data.text))
    }
  }), _c('section', {
    staticClass: "clients"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("Select Clients")]), _vm._l((_vm.info.data.clients), function(list) {
    return _c('div', [_c('h2', {
      staticClass: "heading",
      domProps: {
        "innerHTML": _vm._s(list.header[0].text)
      }
    }), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.html(list.list))
      }
    })])
  })], 2), _c('footer', [_c('copyright', {
    attrs: {
      "credits": "credits"
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__cov-progress",
    style: (_vm.style)
  })
},staticRenderFns: []}

/***/ }),
/* 149 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app",
    attrs: {
      "id": "app",
      "data-route": _vm.$route.name
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.transition
    },
    on: {
      "enter": function($event) {
        _vm.entering = true
      },
      "after-leave": function($event) {
        _vm.entering = false
      }
    }
  }, [_c('keep-alive', [_c('router-view', {
    attrs: {
      "currentData": _vm.current,
      "projects": _vm.projects,
      "info": _vm.info,
      "entering": _vm.entering,
      "savedPosition": _vm.savedPosition
    }
  })], 1)], 1), _c('vue-progress-bar')], 1)
},staticRenderFns: []}

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projects),
      expression: "projects"
    }],
    staticClass: "info-page-wrapper"
  }, [_c('Info', {
    attrs: {
      "info": _vm.info
    }
  })], 1), _c('header', {
    class: {
      "show--info": _vm.showInfo, "translucent--bg": (_vm.projectView || _vm.currentView), "mobile-grey-slide": (_vm.mobileGreySlide && _vm.st <= 0)
    }
  }, [_c('div', {
    staticClass: "bar",
    on: {
      "mouseenter": function($event) {
        _vm.showMenu = true
      },
      "mouseleave": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_c('transition', {
    attrs: {
      "name": "intro"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.projects),
      expression: "!projects"
    }],
    staticClass: "bar",
    staticStyle: {
      "z-index": "51",
      "background": "white !important"
    }
  }, [_c('span', {
    staticClass: "heading"
  }, [_vm._v("Matthieu Lavanchy")])])]), _c('div', {
    staticClass: "bar",
    class: {
      'show--title': _vm.titleVisible, 'hidden--title': !_vm.titleVisible
    }
  }, [_c('span', {
    staticClass: "serif",
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), _c('transition', {
    attrs: {
      "name": _vm.infoTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.showMenu && !_vm.projectViewMobile) || (_vm.showInfo && !_vm.projectViewMobile)),
      expression: "(showMenu && !projectViewMobile) || (showInfo && !projectViewMobile)"
    }],
    staticClass: "bar"
  }, [_c('navv', {
    attrs: {
      "type": "top",
      "visible": true,
      "showInfo": _vm.showInfo
    }
  })], 1)])], 1)]), _c('div', {
    staticClass: "projects",
    class: _vm.classes
  }, [_c('transition', {
    attrs: {
      "name": "intro"
    }
  }, [(_vm.projects) ? _c('div', {
    ref: "scrollbody",
    staticClass: "main"
  }, [_c('div', {
    ref: "current",
    attrs: {
      "id": "current"
    }
  }, [_c('current', {
    attrs: {
      "current": _vm.currentData
    }
  })], 1), _c('div', {
    ref: "projects",
    staticClass: "thumbs",
    attrs: {
      "id": "projects"
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return _c('div', [_c('a', {
      style: ('background-image: url(' + _vm.thumb(project) + ')'),
      attrs: {
        "data-imgsize": _vm.thumbSize
      },
      on: {
        "click": function($event) {
          _vm.open(index)
        },
        "mouseenter": function($event) {
          _vm.thumbHover(project.data.title)
        },
        "mouseleave": function($event) {
          _vm.hideTitle(200)
        }
      }
    })])
  })), _c('div', {
    ref: "viewer",
    attrs: {
      "id": "viewer"
    },
    on: {
      "click": _vm.viewerClick
    }
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition
    }
  }, _vm._l((_vm.projects), function(project, index) {
    return (index === _vm.current) ? _c('project', {
      key: index,
      attrs: {
        "title": _vm.projectView ? _vm.html(project.data.title) : '',
        "current": _vm.currentSlide,
        "slides": project.data.slides,
        "preload": _vm.projects[_vm.nextIndex].data.slides,
        "transition": _vm.transition
      },
      on: {
        "imgHover": function($event) {
          _vm.showTitle(project.data.title, true)
        },
        "imgLeave": _vm.hideTitle
      }
    }) : _vm._e()
  }))], 1)]) : _vm._e()])], 1)])
},staticRenderFns: []}

/***/ }),
/* 151 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: {
      top: _vm.type === "top", bottom: _vm.type === "bottom", "is-scrolling": _vm.isScrolling, "show--info": _vm.showInfo
    },
    attrs: {
      "data-visible": _vm.visible
    }
  }, [_c('button', {
    staticClass: "wrap-link",
    class: {
      'is-active': _vm.$route.name === 'Current'
    },
    on: {
      "click": function($event) {
        _vm.navto("current")
      }
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Current")])]), _c('button', {
    staticClass: "wrap-link",
    class: {
      'is-active': _vm.$route.name === 'Projects'
    },
    on: {
      "click": function($event) {
        _vm.navto("projects")
      }
    }
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("Projects")])]), _c('button', {
    staticClass: "wrap-link",
    class: {
      'is-active': _vm.$route.name === 'Info'
    },
    on: {
      "click": function($event) {
        _vm.navto("info")
      }
    }
  }, [_c('div', {
    staticClass: "heading desktop"
  }, [_vm._v("Information")]), _c('div', {
    staticClass: "heading mobile"
  }, [_vm._v("Info")])])])
},staticRenderFns: []}

/***/ }),
/* 152 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "project"
  }, [_c('div', {
    staticClass: "slideshow"
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.current === 0),
      expression: "current === 0"
    }],
    key: 0,
    staticClass: "slide title-slide"
  }, [_c('header', [_c('div', {
    staticClass: "bar serif"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })])])]), _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.current === index + 1),
        expression: "current === index + 1"
      }],
      key: index + 1,
      staticClass: "slide"
    }, [_c('figure', [_c('div', {
      class: {
        'diptych': !_vm.empty(slide.image_2)
      },
      on: {
        "mouseenter": _vm.imgHover,
        "mouseleave": function($event) {
          _vm.imgHover(false)
        }
      }
    }, [(!_vm.empty(slide.image_1)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(slide.image_1.url, _vm.isPortrait(slide.image_1)),
        "data-portrait": _vm.isPortrait(slide.image_1)
      }
    }) : _vm._e(), (!_vm.empty(slide.image_2)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(slide.image_2.url, _vm.isPortrait(slide.image_2)),
        "data-portrait": _vm.isPortrait(slide.image_2)
      }
    }) : _vm._e()])])])
  })], 2)], 1), (_vm.preload) ? _c('div', {
    staticClass: "preload"
  }, [_vm._l((_vm.preload), function(item) {
    return [(!_vm.empty(item.image_1)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(item.image_1.url, _vm.isPortrait(item.image_1))
      }
    }) : _vm._e(), (!_vm.empty(item.image_2)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(item.image_2.url, _vm.isPortrait(item.image_2))
      }
    }) : _vm._e()]
  })], 2) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "current-project"
  }, [_c('div', {
    staticClass: "current-slideshow"
  }, [_c('transition-group', {
    attrs: {
      "name": _vm.transition
    }
  }, _vm._l((_vm.slides), function(slide, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.current === index),
        expression: "current === index"
      }],
      key: index,
      staticClass: "slide"
    }, [(slide.gray_slide) ? _c('header', {
      staticClass: "grey-slide"
    }, [(slide.caption.length && slide.caption[0].text) ? _c('div', {
      staticClass: "bar serif"
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(slide.caption[0].text)
      }
    })]) : _vm._e()]) : _c('figure', [_c('div', {
      class: {
        'diptych': !_vm.empty(slide.image_2)
      },
      on: {
        "mouseenter": _vm.imgHover,
        "mouseleave": function($event) {
          _vm.imgHover(false)
        }
      }
    }, [(!_vm.empty(slide.image_1)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(slide.image_1.url, _vm.isPortrait(slide.image_1)),
        "data-portrait": _vm.isPortrait(slide.image_1)
      }
    }) : _vm._e(), (!_vm.empty(slide.image_2)) ? _c('img', {
      attrs: {
        "src": _vm.imgSrc(slide.image_2.url, _vm.isPortrait(slide.image_2)),
        "data-portrait": _vm.isPortrait(slide.image_2)
      }
    }) : _vm._e()])])])
  }))], 1)])
},staticRenderFns: []}

/***/ }),
/* 154 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "copyright caption"
  }, [_vm._v(" Copyright " + _vm._s(_vm.year) + " Matthieu Lavanchy"), (_vm.credits) ? _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showCredits),
      expression: "!showCredits"
    }],
    on: {
      "click": function($event) {
        _vm.showCredits = !_vm.showCredits
      }
    }
  }, [_vm._v(". Site Credits")]) : _vm._e(), _c('br'), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCredits),
      expression: "showCredits"
    }]
  }, [_vm._v(" Site designed by "), _c('a', {
    attrs: {
      "href": "http://spencerfenton.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("Spencer Fenton")]), _vm._v(" & developed by "), _c('a', {
    attrs: {
      "href": "http://everettwilliams.info",
      "target": "_blank"
    }
  }, [_vm._v("Everett Williams")])])])
},staticRenderFns: []}

/***/ }),
/* 155 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.current && _vm.slides) ? _c('div', {
    staticClass: "current"
  }, [_c('div', {
    ref: "viewer",
    attrs: {
      "id": "viewer2"
    },
    on: {
      "click": _vm.viewerClick
    }
  }, [_c('current-project', {
    attrs: {
      "title": "Current",
      "current": _vm.currentSlide,
      "slides": _vm.slides,
      "transition": _vm.transition
    },
    on: {
      "imgHover": function($event) {
        _vm.showTitle(_vm.slides[_vm.currentSlide].caption, true)
      },
      "imgLeave": _vm.hideTitle
    }
  })], 1)]) : _vm._e()
},staticRenderFns: []}

/***/ })
]),[56]);


// WEBPACK FOOTER //
// static/js/app.e8499d55039f14321a7b.js